import React from "react";
import ReactDOM from "react-dom";
import InputCustom from "./InputCustom";
import Button from "./Button";
import styles from "../styles/Viagem.module.scss";

const ehMenorDeIdade = (data_nascimento) => {
	if (!data_nascimento) return false;

	const nascimento = new Date(data_nascimento);
	const hoje = new Date();
	let idade = hoje.getFullYear() - nascimento.getFullYear();
	const mes_diferenca = hoje.getMonth() - nascimento.getMonth();

	if (mes_diferenca < 0 || (mes_diferenca === 0 && hoje.getDate() < nascimento.getDate())) {
		idade--;
	}

	return idade < 18;
};

export default function ModalPassageirosViagem({ aberto, passageiros, onFechar, onChange }) {
	if (!aberto) return null;

	return ReactDOM.createPortal(
		<div className={styles.overlay} onClick={onFechar}>
			<div className={styles.modalLarge} onClick={(e) => e.stopPropagation()}>
				<div className={styles.modalHeader}>
					<p className={styles.modalTitulo}>Relação de passageiros</p>
					<button className={styles.modalFechar} onClick={onFechar}>×</button>
				</div>

				{passageiros.map((passageiro, index) => (
					<div key={index}>
						<p className={styles.passageiroLabel}>Passageiro {index + 1}</p>

						<div className={styles.gridTresColunas}>
							<InputCustom
								label="Nome completo"
								name={`nome_completo_${index}`}
								type="text"
								value={passageiro.nome_completo}
								onChange={(e) => onChange(index, "nome_completo", e.target.value)}
								required
							/>

							<InputCustom
								label="Documento"
								name={`documento_${index}`}
								type="text"
								value={passageiro.documento}
								onChange={(e) => onChange(index, "documento", e.target.value)}
								required
							/>

							<InputCustom
								label="Data de nascimento"
								name={`data_nascimento_${index}`}
								type="date"
								value={passageiro.data_nascimento}
								onChange={(e) => onChange(index, "data_nascimento", e.target.value)}
								required
							/>
						</div>

						{ehMenorDeIdade(passageiro.data_nascimento) && (
							<div className={`${styles.gridDuasColunas} ${styles.campoMargem}`}>
								<InputCustom
									label="Nome do responsável"
									name={`nome_responsavel_${index}`}
									type="text"
									value={passageiro.nome_responsavel}
									onChange={(e) => onChange(index, "nome_responsavel", e.target.value)}
									required
								/>

								<InputCustom
									label="Documento do responsável"
									name={`documento_responsavel_${index}`}
									type="text"
									value={passageiro.documento_responsavel}
									onChange={(e) => onChange(index, "documento_responsavel", e.target.value)}
									required
								/>
							</div>
						)}

						{index < passageiros.length - 1 && <span className={styles.passageiroSeparador} />}
					</div>
				))}

				<div className={styles.modalBotoes}>
					<Button type="button" variant="default" outlined size="md" onClick={onFechar}>
						Cancelar
					</Button>

					<Button type="button" variant="primary" size="md" onClick={onFechar}>
						Salvar dados
					</Button>
				</div>
			</div>
		</div>,
		document.body
	);
}
